/* ==========================================================================
   JM27 kurv-popud — adfærdslag oven på temaets <cart-notification>
   (assets/cart-components.js). Motoren er uændret: den åbner/lukker, skifter
   antal og bytter #minicart-form ud efter hvert læg-i-kurv. Dette lag:
   - "Lagt i kurven" vs. "Din kurv": åbnes popuden fra headerens Kurv-link,
     vises hele kurven; ellers fremhæves de linjer, der lige er kommet til
     (nye eller højere antal ift. et øjebliksbillede taget ved sideindlæsning
     og ved hver lukning) — alle, også tilbehør fra samme klik. Resten foldes
     sammen bag "N varer · Vis".
   - Anbefalinger ("Passer godt sammen med"): først butikkens egne valg
     (custom.bought_together, <template data-jm27-bt> i jm27-drawer-body),
     derefter Shopify Product Recommendations + sections/cart-recs-27.liquid,
     med hurtig "+" kun for varer der ikke skal sættes op først.
   - Betingelser: en tryk på den deaktiverede kasse-knap viser en hjælpetekst
     og flytter fokus til afkrydsningsfeltet i stedet for ingenting.
   - Esc lukker, fokus låses i popuden og vender tilbage bagefter,
     træk ned i håndtaget lukker bundarket på mobil.
   Alt re-initialiseres efter hver udskiftning af #minicart-form
   (MutationObserver, childList) — de 16 steder i temaet, der bytter indholdet,
   behøver ikke kende til dette lag.
   Klik-handlere erstatter ALDRIG det klikkede element synkront (det ville få
   handleBodyClick til at tro, at klikket var udenfor, og lukke popuden).
   ========================================================================== */
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 767.98px)');
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function init() {
    var root = document.getElementById('minicart_wrapper');
    if (!root) return;
    var panel = root.querySelector('.minicart__wrapper.jm27-dr');
    var host = root.querySelector('#minicart-form');
    if (!panel || !host) return;

    var state = {
      mode: 'list',
      featured: null,
      expanded: true,
      fromHeader: false,
      snapshot: readLines(),
      pendingSnapshot: null,
      lastFocus: null,
      wasOpen: root.classList.contains('open')
    };
    var recCache = new Map();

    function cart() { return document.querySelector('cart-notification'); }

    function lineEls() { return Array.prototype.slice.call(host.querySelectorAll('[data-jm27-line]')); }

    function readLines() {
      var map = {};
      (host ? host.querySelectorAll('[data-jm27-line]') : []).forEach(function (el) {
        map[el.getAttribute('data-key')] = parseInt(el.getAttribute('data-qty'), 10) || 0;
      });
      return map;
    }

    /* Linjerne der lige er kommet til (nye eller højere antal) — ALLE, så
       kunden ser alt det, ét klik lagde i kurven: "Tilføj begge/alle" på
       produktsiden, Loopys lampe + lampekit, kroge-guidens sæt pr. sted.
       (Før 2026-11-02 blev kun sidens eget produkt vist, og resten lå skjult
       bag "N varer · Vis" — kunden kunne ikke se, at tilbehøret kom med.)
       Står man på en produktside, kommer sidens produkt først i listen; det
       er den første nøgle, der bestemmer anbefalingerne (recProductId). */
    function addedKeys(before) {
      var now = readLines();
      var hits = lineEls().filter(function (el) {
        var k = el.getAttribute('data-key');
        return !(k in before) || now[k] > before[k];
      });
      if (!hits.length) return null;
      var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
      if (m && hits.length > 1) {
        var handle = decodeURIComponent(m[1]);
        var own = hits.filter(function (el) { return el.getAttribute('data-handle') === handle; });
        hits = own.concat(hits.filter(function (el) { return own.indexOf(el) === -1; }));
      }
      return hits.map(function (el) { return el.getAttribute('data-key'); });
    }

    function isFeatured(el) {
      return state.mode === 'added' && !!state.featured && state.featured.indexOf(el.getAttribute('data-key')) !== -1;
    }

    function apply() {
      var lines = lineEls();
      if (state.featured) {
        state.featured = state.featured.filter(function (k) {
          return lines.some(function (el) { return el.getAttribute('data-key') === k; });
        });
        if (!state.featured.length) state.featured = null;
      }
      if (state.mode === 'added' && !state.featured) state.mode = 'list';
      if (state.mode === 'list') state.expanded = true;
      panel.setAttribute('data-mode', state.mode);
      panel.classList.toggle('is-expanded', state.expanded);
      lines.forEach(function (el) {
        el.classList.toggle('is-featured', isFeatured(el));
      });
      var toggle = host.querySelector('[data-jm27-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', state.expanded ? 'true' : 'false');
      decorateTerms();
      /* Anbefalinger hentes først, når popuden faktisk er åben */
      if (root.classList.contains('open')) loadRecs();
    }

    /* ---------- Anbefalinger ---------- */
    function recProductId() {
      var el = null;
      if (state.mode === 'added' && state.featured) {
        el = host.querySelector('[data-jm27-line][data-key="' + cssEscape(state.featured[0]) + '"]');
      }
      if (!el) el = host.querySelector('[data-jm27-line]');
      return el ? el.getAttribute('data-product-id') : null;
    }

    function loadRecs() {
      var box = host.querySelector('[data-jm27-recs]');
      if (!box) return;
      var pid = recProductId();
      if (!pid) { box.hidden = true; return; }
      if (box.getAttribute('data-for') === pid) return;
      box.setAttribute('data-for', pid);
      var inCart = (box.getAttribute('data-in-cart') || '').split(',');
      var seen = {};
      var fresh = function (c) {
        var id = c.getAttribute('data-product-id');
        if (!id || seen[id] || inCart.indexOf(id) !== -1) return false;
        seen[id] = true;
        return true;
      };
      /* Butikkens egne valg (custom.bought_together) først, i den rækkefølge
         de er sat i Admin; Shopifys automatiske anbefalinger fylder op. */
      var tpl = box.querySelector('template[data-jm27-bt="' + pid + '"]');
      var curated = tpl ? Array.prototype.slice.call(tpl.content.querySelectorAll('.jm27-card')).filter(fresh) : [];
      var render = function (html) {
        if (!box.isConnected || box.getAttribute('data-for') !== pid) return;
        var doc = new DOMParser().parseFromString(html || '', 'text/html');
        /* Shopifys relevans-rækkefølge bevares. At sortere "+"-varer først
           skubbede relevante varer med varianter (fx kroge) bag urelaterede
           dyre lamper. */
        var related = Array.prototype.slice.call(doc.querySelectorAll('.jm27-card')).filter(fresh);
        var cards = curated.concat(related).slice(0, 3);
        var grid = box.querySelector('[data-jm27-recs-grid]');
        grid.replaceChildren.apply(grid, cards.map(function (c) { return document.importNode(c, true); }));
        box.hidden = cards.length === 0;
      };
      if (curated.length >= 3) { render(''); return; }
      if (recCache.has(pid)) { render(recCache.get(pid)); return; }
      var url = (box.getAttribute('data-url') || '/recommendations/products') +
        '?product_id=' + encodeURIComponent(pid) + '&limit=8&section_id=cart-recs-27';
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { recCache.set(pid, html); render(html); })
        .catch(function () { box.hidden = true; });
    }

    function swapSections(sections) {
      var c = cart();
      if (!c || !sections || typeof c.getSectionsToRender !== 'function') return;
      c.getSectionsToRender().forEach(function (s) {
        var target = document.getElementById(s.id);
        var html = sections[s.id];
        if (!target || !html) return;
        var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('#minicart-form');
        if (inner) target.innerHTML = inner.innerHTML;
      });
      if (typeof c.cartAction === 'function') c.cartAction();
    }

    function updateCount() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (c.item_count === undefined) return;
          document.querySelectorAll('.cart-count').forEach(function (el) {
            el.innerHTML = el.classList.contains('cart-count-drawer') ? '(' + c.item_count + ')' : c.item_count > 100 ? '~' : c.item_count;
          });
        })
        .catch(function () {});
    }

    function addRec(btn) {
      var id = parseInt(btn.getAttribute('data-jm27-add'), 10);
      if (!id || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      var box = host.querySelector('[data-jm27-recs]');
      var err = box && box.querySelector('[data-jm27-recs-error]');
      if (err) err.hidden = true;
      var c = cart();
      var ids = c && typeof c.getSectionsToRender === 'function' ? c.getSectionsToRender().map(function (s) { return s.id; }) : ['minicart-form'];
      state.pendingSnapshot = readLines();
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: ids, sections_url: window.location.pathname })
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (body) {
            if (!r.ok || body.status || body.errors) throw new Error(body.description || body.message || '');
            return body;
          });
        })
        .then(function (res) {
          swapSections(res.sections);
          updateCount();
        })
        .catch(function (e) {
          state.pendingSnapshot = null;
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          if (err) {
            err.textContent = (e && e.message) || 'Varen kunne ikke lægges i kurven. Prøv igen.';
            err.hidden = false;
          }
        });
    }

    /* ---------- Betingelser ---------- */
    function decorateTerms() {
      var terms = host.querySelector('[data-jm27-terms]');
      if (!terms) return;
      /* Første link åbnes som popup af <terms-conditions>; privatlivs-linket
         åbnes i en ny fane, så kurven ikke forlades. */
      var links = terms.querySelectorAll('a');
      for (var i = 1; i < links.length; i++) {
        links[i].setAttribute('target', '_blank');
        links[i].setAttribute('rel', 'noopener');
      }
    }

    function showTermsHint() {
      var hint = host.querySelector('[data-jm27-hint]');
      var terms = host.querySelector('[data-jm27-terms]');
      var box = terms && terms.querySelector('input[type="checkbox"]');
      if (hint) hint.hidden = false;
      if (terms) {
        terms.classList.remove('is-attention');
        void terms.offsetWidth;
        terms.classList.add('is-attention');
      }
      if (box) box.focus({ preventScroll: true });
    }

    /* ---------- Åben / luk ---------- */
    function focusables() {
      return Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
    }

    function onOpen() {
      if (state.fromHeader) {
        state.mode = 'list';
        state.featured = null;
      } else {
        var keys = addedKeys(state.snapshot);
        state.mode = keys ? 'added' : 'list';
        state.featured = keys;
      }
      state.fromHeader = false;
      state.expanded = state.mode === 'list';
      if (!state.lastFocus) state.lastFocus = document.activeElement;
      var hint = host.querySelector('[data-jm27-hint]');
      if (hint) hint.hidden = true;
      var scroller = host.querySelector('[data-jm27-scroll]');
      if (scroller) scroller.scrollTop = 0;
      apply();
      var closeBtn = panel.querySelector('.close-cart-button');
      window.setTimeout(function () {
        if (root.classList.contains('open') && closeBtn && !panel.contains(document.activeElement)) {
          closeBtn.focus({ preventScroll: true });
        }
      }, 280);
    }

    function onClose() {
      state.snapshot = readLines();
      state.pendingSnapshot = null;
      panel.style.transform = '';
      panel.classList.remove('is-dragging');
      var back = state.lastFocus;
      state.lastFocus = null;
      if (back && back.isConnected && typeof back.focus === 'function' && panel.contains(document.activeElement)) {
        back.focus({ preventScroll: true });
      }
    }

    new MutationObserver(function () {
      var open = root.classList.contains('open');
      if (open && !state.wasOpen) onOpen();
      if (!open && state.wasOpen) onClose();
      state.wasOpen = open;
    }).observe(root, { attributes: true, attributeFilter: ['class'] });

    /* Efter hver udskiftning af popudens indhold */
    new MutationObserver(function () {
      if (state.pendingSnapshot) {
        var keys = addedKeys(state.pendingSnapshot);
        state.pendingSnapshot = null;
        if (keys) {
          state.mode = 'added';
          state.featured = keys;
          state.expanded = false;
        }
      }
      apply();
      /* Øjebliksbilledet opdateres KUN ved sideindlæsning og lukning: i
         læg-i-kurv-flowene byttes indholdet ud FØR popuden åbnes. */
    }).observe(host, { childList: true });

    /* Headerens Kurv-link → hele kurven (capture, før temaets egen handler) */
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('.minicart__action');
      if (t && !root.classList.contains('open')) {
        state.fromHeader = true;
        state.lastFocus = t;
      }
    }, true);

    /* Klik inde i popuden */
    panel.addEventListener('click', function (e) {
      var t = e.target;
      var toggle = t.closest('[data-jm27-toggle]');
      if (toggle) {
        e.preventDefault();
        state.expanded = !state.expanded;
        apply();
        if (state.expanded) {
          var scroller = host.querySelector('[data-jm27-scroll]');
          var first = host.querySelector('[data-jm27-lines]');
          if (scroller && first) scroller.scrollTo({ top: Math.max(0, first.offsetTop - 16), behavior: 'smooth' });
        }
        return;
      }
      var add = t.closest('[data-jm27-add]');
      if (add) {
        e.preventDefault();
        addRec(add);
        return;
      }
      var wrap = t.closest('[data-jm27-checkout-wrap]');
      if (wrap) {
        var btn = wrap.querySelector('.btn-checkout');
        if (btn && btn.disabled) {
          e.preventDefault();
          showTermsHint();
        }
      }
    });

    panel.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('conditions_form_minicart')) {
        var hint = host.querySelector('[data-jm27-hint]');
        if (hint && e.target.checked) hint.hidden = true;
        var terms = host.querySelector('[data-jm27-terms]');
        if (terms) terms.classList.remove('is-attention');
      }
    });

    /* Esc + fokusfælde */
    document.addEventListener('keydown', function (e) {
      if (!root.classList.contains('open')) return;
      if (document.querySelector('.tingle-modal--visible')) return; /* betingelses-popup ovenpå */
      if (e.key === 'Escape' || e.key === 'Esc') {
        var c = cart();
        if (c && typeof c.close === 'function') { e.preventDefault(); c.close(); }
        return;
      }
      if (e.key !== 'Tab') return;
      var list = focusables();
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (!panel.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    /* Træk ned for at lukke (bundark på mobil) */
    var head = panel.querySelector('[data-jm27-drag]');
    if (head) {
      var drag = null;
      head.addEventListener('pointerdown', function (e) {
        if (!MOBILE.matches || e.button > 0) return;
        if (e.target.closest('button, a')) return;
        drag = { y: e.clientY, t: Date.now(), dy: 0, id: e.pointerId };
        panel.classList.add('is-dragging');
        try { head.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      });
      head.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        drag.dy = Math.max(0, e.clientY - drag.y);
        panel.style.transform = 'translate3d(0,' + drag.dy + 'px,0)';
      });
      var end = function (e) {
        if (!drag || (e && e.pointerId !== drag.id)) return;
        var dy = drag.dy;
        var speed = dy / Math.max(1, Date.now() - drag.t);
        drag = null;
        panel.classList.remove('is-dragging');
        if (dy > 90 || (dy > 24 && speed > 0.5)) {
          /* Glid videre ned fra fingerens position; onClose rydder bagefter */
          panel.style.transform = 'translate3d(0,100%,0)';
          var c = cart();
          if (c && typeof c.close === 'function') c.close();
        } else {
          panel.style.transform = '';
        }
      };
      head.addEventListener('pointerup', end);
      head.addEventListener('pointercancel', end);
    }

    function cssEscape(v) {
      return window.CSS && typeof window.CSS.escape === 'function' ? window.CSS.escape(v) : String(v).replace(/"/g, '\\"');
    }

    /* Partner-ads-oprydningen (assets/partner-ads-cleanup.js) har skrevet
       kurvens linjer om, så de har nye keys. Hent popuden igen, så antal/fjern
       rammer de rigtige linjer, og "Lagt i kurven" ikke tror, de er nye. */
    document.addEventListener('jmd:cart-changed', function () {
      var c = cart();
      var ids = c && typeof c.getSectionsToRender === 'function' ? c.getSectionsToRender().map(function (s) { return s.id; }) : ['minicart-form'];
      fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids.join(',')))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (sections) {
          if (!sections) return;
          swapSections(sections);
          state.snapshot = readLines();
        })
        .catch(function () {});
    });

    apply();
    window.JM27Drawer = { refresh: apply, state: state };
  }

  function start() {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-notification').then(init);
    } else {
      init();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
